import React from "react";
import { PulseSpinner } from "react-spinners-kit";

export function ItemSpinner() {
	return <PulseSpinner />;
}
